import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { ApplicationFeaturesProps, FeatureOption } from "../../CompanyEditor.types";

import {
  TextField,
  Typography,
  Chip,
  Autocomplete,
  AutocompleteRenderInputParams,
} from "@components/base";

const ApplicationFeatures: FC<ApplicationFeaturesProps> = ({
  availableFeatures,
  selectedFeatureOptions,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="subtitle2" sx={{ mt: 2 }}>
        {t("admin.applicationFeatures")}
      </Typography>
      <Autocomplete<FeatureOption, true>
        multiple
        options={availableFeatures}
        getOptionLabel={(option: FeatureOption) => option.label}
        value={selectedFeatureOptions}
        onChange={onChange}
        isOptionEqualToValue={(option: FeatureOption, value: FeatureOption) =>
          option.id === value.id
        }
        sx={{
          "& .MuiAutocomplete-inputRoot": {
            minHeight: 56,
            paddingTop: "4px",
            paddingBottom: "4px",
          },
        }}
        renderInput={(params: AutocompleteRenderInputParams) => (
          <TextField {...params} placeholder={t("admin.selectFeatures")} />
        )}
        renderTags={(value: FeatureOption[], getTagProps) =>
          value.map((option: FeatureOption, index: number) => (
            <Chip
              label={option.label}
              {...getTagProps({ index })}
              key={option.id}
              color="blue1"
              size="small"
              sx={{
                m: 0.25,
                height: 24,
                "& .MuiChip-label": {
                  px: 1,
                },
                "& .MuiChip-deleteIcon": {
                  ml: 0,
                  mr: 0.5,
                },
              }}
            />
          ))
        }
      />
    </>
  );
};

export default ApplicationFeatures;
